import FileSaver from 'file-saver';
import { Parser } from 'json2csv';
import i18n from "i18n";
import { cloneDeep } from "lodash";
import { saveAs } from "file-saver";

export const fromUrl = (url) => {
  saveAs(url);
}

// example:
// const downloadORGCsv = useCallback(async () => {
//   const columns = defaultColumns();
//   let fields = [];
//   let headers = [];
//   for (const [colIndex, col] of columns.entries()) {
//     headers.push(col.label); // or t(col.label)
//     fields.push(col.downloadName || col.accessor);
//   }
//   const transList = await licensesService.translateList(origin.originDataList);

//   const fileName = `${'ORG_License'}_${dayjs().format(timeFormat.csvDownloadFormat)}.csv`;
//   jsonToCsv(fileName, headers, fields, transList);
// }, []);

export const jsonToCsv = (fileName, headers, fields, data) => {
  try {
    const t = i18n.t;
    let index = 1;
    const transforms = (item) => {  // improve data here~
      for (let [key, value] of Object.entries(item)) {
        if (typeof value === 'string') {
          item.index = index;
          item[key] = t(value); // tmp~
        }
      }
      index++;
      return item;
    };
    const opts = {
      fields: ['index'].concat(fields),
      excelStrings: true,
      header: false,
      transforms,
      // withBOM: true,
    };

    const json2csvParser = new Parser(opts);
    const csv = json2csvParser.parse(cloneDeep(data));
    const transHeaders = headers.map((val) => { return t(val); }); // tmp~
    const headersStr = ['#'].concat(transHeaders).join(',');
    const blob = new Blob(['\uFEFF' + headersStr + '\n' + csv], { type: 'text/csv;charset=utf-8' });
    FileSaver.saveAs(blob, fileName);
  } catch (err) {
    console.error(`jsonToCsv: ${err}`);
  }
};

export const textToCsv = (fileName, csv) => {
  const blob = new Blob([csv], { type: 'text/plain;charset=utf-8' });
  saveAs(blob, fileName);
}